(function () {
  // Pillow comparison toggle
  document.querySelectorAll('[data-align]').forEach(function (stage) {
    var buttons = stage.querySelectorAll('[data-set]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        stage.setAttribute('data-state', btn.dataset.set);
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      });
    });
  });

  // Anatomy: highlight the pin of the part being hovered or focused
  document.querySelectorAll('[data-pin-target]').forEach(function (part) {
    var section = part.closest('section');
    var pin = section && section.querySelector('[data-pin="' + part.dataset.pinTarget + '"]');
    if (!pin) return;
    var on = function () { pin.classList.add('is-on'); };
    var off = function () { pin.classList.remove('is-on'); };
    part.addEventListener('mouseenter', on);
    part.addEventListener('mouseleave', off);
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-src]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) { main.src = btn.dataset.src; main.removeAttribute('srcset'); }
        g.querySelectorAll('[data-src]').forEach(function (b) { b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  // Mobile menu: close after tapping a link or tapping outside
  document.querySelectorAll('.rs-menu').forEach(function (m) {
    m.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { m.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) {
      if (m.hasAttribute('open') && !m.contains(e.target)) m.removeAttribute('open');
    });
  });

  // Rotating announcement bar
  var bar = document.querySelector('[data-bar]');
  if (bar) {
    var msgs = bar.querySelectorAll('p');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (msgs.length > 1 && !reduce) {
      var cur = 0;
      setInterval(function () {
        msgs[cur].hidden = true;
        cur = (cur + 1) % msgs.length;
        msgs[cur].hidden = false;
      }, 5000);
    }
  }

  // Welcome offer: email for 10% off
  var dlg = document.querySelector('[data-welcome]');
  if (dlg) {
    var KEY = 'rs_welcome';
    var get = function () { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
    var set = function (v) { try { localStorage.setItem(KEY, v); } catch (e) {} };
    var openW = function () {
      if (dlg.open) return;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    };
    var closeW = function () {
      if (get() !== 'done') set(String(Date.now()));
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    };
    var posted = dlg.querySelector('[data-code], .rs-welcome-err');
    if (posted) {
      if (dlg.querySelector('[data-code]')) set('done');
      openW();
    } else {
      var st = get();
      var snoozed = st === 'done' || (st && Date.now() - parseInt(st, 10) < 7 * 864e5);
      if (!snoozed) {
        var fired = false;
        var trigger = function () { if (fired) return; fired = true; openW(); };
        setTimeout(trigger, (parseInt(dlg.dataset.delay, 10) || 12) * 1000);
        document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) trigger(); });
      }
    }
    dlg.querySelectorAll('[data-welcome-close]').forEach(function (b) { b.addEventListener('click', closeW); });
    dlg.addEventListener('cancel', function () { if (get() !== 'done') set(String(Date.now())); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeW(); });
    document.querySelectorAll('[data-welcome-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openW(); });
    });
    var copy = dlg.querySelector('[data-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var code = dlg.querySelector('[data-code]').textContent.trim();
        var done = function () { copy.textContent = 'Copied'; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () {});
      });
    }
  }

  // Variant picker
  document.querySelectorAll('[data-buy-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var sets = form.querySelectorAll('.rs-opt');
    var price = document.querySelector('[data-price]');
    var main = document.querySelector('[data-gallery-main]');
    var btn = form.querySelector('button[type="submit"]');
    var update = function () {
      var chosen = [];
      sets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        chosen.push(c ? c.value : null);
        var lab = fs.querySelector('[data-option-label]');
        if (lab && c) lab.textContent = c.value;
      });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) return;
      idInput.value = v.id;
      if (price) price.firstChild.textContent = v.price;
      if (main && v.image) { main.src = v.image; main.removeAttribute('srcset'); }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      var sp = document.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = v.price;
      var sb = document.querySelector('[data-sticky-btn]');
      if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
    };
    sets.forEach(function (fs) { fs.addEventListener('change', update); });
  });

  // Sticky add to cart on phones: appears once the main button has scrolled out of view above
  var sticky = document.querySelector('[data-sticky-buy]');
  var mainBtn = document.querySelector('[data-buy-form] button[type="submit"]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    var sBtn = sticky.querySelector('[data-sticky-btn]');
    var show = function (on) {
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (sBtn) sBtn.tabIndex = on ? 0 : -1;
    };
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      show(!e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(mainBtn);
    if (sBtn) sBtn.addEventListener('click', function () { mainBtn.click(); });
  }

  // Cart: - / + stepper. The number changes at once, then the cart saves after a short pause so quick taps add up.
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    var timer = null;
    var save = function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        form.classList.add('is-busy');
        var u = document.createElement('input');
        u.type = 'hidden'; u.name = 'update'; u.value = '1';
        form.appendChild(u);
        form.submit();
      }, 450);
    };
    form.querySelectorAll('[data-step-btn]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var input = b.parentNode.querySelector('.rs-step-input');
        if (!input) return;
        e.preventDefault();
        if (form.classList.contains('is-busy')) return;
        var v = (parseInt(input.value, 10) || 0) + parseInt(b.dataset.stepBtn, 10);
        input.value = Math.max(0, v);
        save();
      });
    });
    form.querySelectorAll('.rs-step-input').forEach(function (i) { i.addEventListener('change', save); });
  });

  // Preselect quantity from ?qty=2 (links from the homepage offer)
  var qty = new URLSearchParams(location.search).get('qty');
  if (qty) {
    var radio = document.querySelector('.rs-qty input[value="' + qty + '"]');
    if (radio) radio.checked = true;
  }
})();
